import type { AppVueRouter } from '@modules/core/services/router/types';
import type { TranslationKeysMapper } from '@modules/i18n/types';
import type { AppMenu } from '@modules/sidebar/utils';
import { AffiliatesApprovedProfileModule } from '@modules/affiliates-approved/submodules/affiliate-profile/AffiliateProfileModule';
import { AppModule } from '@modules/core/plugins/AppModule';
import { useI18n } from '@modules/i18n/composables';
import { ADMIN_PARTNERS_MENU_ITEM, TRANSLATION_GROUP_SIDEBAR } from '@modules/sidebar/constants';

import {
  ADMIN_AFFILIATES_APPROVED_LIST_ROUTE_NAME,
  ADMIN_AFFILIATES_APPROVED_ROUTE_NAME,
  AFFILIATES_APPROVED_PERMISSIONS,
  TRANSLATION_GROUP_AFFILIATES_APPROVED,
} from './constants';
import { AffiliatesNoneNegativeCarryoverModule } from './submodules/none-negative-carryover/AffiliatesNoneNegativeCarryoverModule';
import { AffiliatesApprovedTrackersSettingsModule } from './submodules/trackers-settings/AffiliateTrackersSettingsModule';
import { getTranslationKeys } from './translations';

export class AffiliatesApprovedModule extends AppModule {
  protected submodules: AppModule[] = [
    new AffiliatesApprovedProfileModule(),
    new AffiliatesApprovedTrackersSettingsModule(),
    new AffiliatesNoneNegativeCarryoverModule(),
  ];

  addRoutes(router: AppVueRouter): void {
    router.addAdminRoute({
      name: ADMIN_AFFILIATES_APPROVED_ROUTE_NAME,
      path: 'partners',
      component: () => import('@modules/core/components/SimpleChildRoutePage/SimpleChildRoutePage.vue'),
      permission: AFFILIATES_APPROVED_PERMISSIONS.AFFILIATES_SHOW,
      redirect: {
        name: ADMIN_AFFILIATES_APPROVED_LIST_ROUTE_NAME,
      },
      keepAliveInclude: 'AffiliatesListPage',
    });

    router.addChildRoute(ADMIN_AFFILIATES_APPROVED_ROUTE_NAME, {
      name: ADMIN_AFFILIATES_APPROVED_LIST_ROUTE_NAME,
      path: '',
      component: () => import('./pages/AffiliatesListPage/AffiliatesListPage.vue'),
    });
  }

  addMenu(menu: AppMenu): void {
    const { getTPath } = useI18n();

    menu.addChildAdminMenuItem(ADMIN_PARTNERS_MENU_ITEM, {
      caption: getTPath(TRANSLATION_GROUP_SIDEBAR, 'PARTNERS_PARTNERS_LIST'),
      to: {
        name: ADMIN_AFFILIATES_APPROVED_ROUTE_NAME,
      },
      permission: AFFILIATES_APPROVED_PERMISSIONS.AFFILIATES_SHOW,
      id: ADMIN_AFFILIATES_APPROVED_ROUTE_NAME,
      order: 30,
    });
  }

  addTranslationKeys(mapper: TranslationKeysMapper): void {
    mapper.addTranslationsMap(TRANSLATION_GROUP_AFFILIATES_APPROVED, getTranslationKeys);
  }
}
